import { render, staticRenderFns } from "./SignUpEmailVerification.vue?vue&type=template&id=93d6dce4&scoped=true"
import script from "./SignUpEmailVerification.vue?vue&type=script&lang=js"
export * from "./SignUpEmailVerification.vue?vue&type=script&lang=js"
import style0 from "./SignUpEmailVerification.vue?vue&type=style&index=0&id=93d6dce4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d6dce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d6dce4')) {
      api.createRecord('93d6dce4', component.options)
    } else {
      api.reload('93d6dce4', component.options)
    }
    module.hot.accept("./SignUpEmailVerification.vue?vue&type=template&id=93d6dce4&scoped=true", function () {
      api.rerender('93d6dce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/SignUpEmailVerification.vue"
export default component.exports